import { ReactNode } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface TopMenuProps {
  className?: string;
  leftSection?: ReactNode;
  centerSection?: ReactNode;
  rightSection?: ReactNode;
  endSection?: ReactNode;
}

export default function TopMenu ({
  className,
  leftSection,
  centerSection,
  rightSection,
  endSection
}: TopMenuProps) {

  return (
    <div className={cn(styles.topMenu, className)}>
      <div className={styles.topMenu__container}>
        <div className={styles.topMenu__left}>
          {leftSection || (
            <div className={styles.topMenu__location}>
              <img
                src="/icons/location_on.svg"
                alt="Location"
                className={styles.topMenu__locationIcon}
              />
              <span className={styles.topMenu__locationText}>Актобе</span>
            </div>
          )}
        </div>

        <div className={styles.topMenu__center}>
          {centerSection}
        </div>

        <div className={styles.topMenu__right}>
          {rightSection}
          {endSection}
        </div>
      </div>
    </div>
  )
}
